/**
 * I18n configuration
 */

export { I18nProvider } from "@amzn/awsui-components-console/i18n";
import messages from "@awsui-i18n-messages";
export const enMessages = messages;
